import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row no-gutters pt-4 border-bottom"
};
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = { class: "col-12" };
const _hoisted_4 = { class: "h5-responsive mb-3 d-inline-block" };
const _hoisted_5 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_open_popup_button = _resolveComponent("open-popup-button");
    const _component_product_condition_info = _resolveComponent("product-condition-info");
    return (_ctx.filterCategories.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterCategories, (category, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "row"
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(category.filterName), 1),
                            (category.filterName == 'Zustand')
                                ? (_openBlock(), _createBlock(_component_open_popup_button, {
                                    key: 0,
                                    "popup-name": "conditionsPopup"
                                }, {
                                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                            _createElementVNode("img", {
                                                class: "conditionsInfo pointerhover",
                                                src: "/images/_new_brand/icons/icon_fragezeichen_full.svg",
                                                alt: "(?)",
                                                width: "20",
                                                height: "20",
                                                style: { "margin": "0 0 8px 10px" }
                                            }, null, -1)
                                        ]))]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.filterValues, (filterValue, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "col-lg-4 col-6 pr-2 pl-sm-3 pl-2 mb-sm-4 mb-3"
                            }, [
                                _createElementVNode("button", {
                                    onClick: ($event) => (_ctx.selectAttribute(`${filterValue.attribute_name}:${filterValue.attribute_value}`)),
                                    class: _normalizeClass(["buttonBase filterButton w-100", [
                                            {
                                                '[ buttonSelected ]': _ctx.attributeInCurrentProduct(filterValue.attribute_name, filterValue.attribute_value),
                                            },
                                            {
                                                '[ buttonNotInSelectionAvailable ]': !_ctx.attributeWithCurrentScopeSelectable(filterValue.attribute_name, filterValue.attribute_value) &&
                                                    !_ctx.attributeInCurrentProduct(filterValue.attribute_name, filterValue.attribute_value),
                                            },
                                            {
                                                '[ buttonAvailable ]': _ctx.attributeWithCurrentScopeSelectable(filterValue.attribute_name, filterValue.attribute_value) &&
                                                    !_ctx.attributeInCurrentProduct(filterValue.attribute_name, filterValue.attribute_value),
                                            },
                                        ]])
                                }, _toDisplayString(filterValue.pretty), 11, _hoisted_5)
                            ]));
                        }), 128))
                    ]));
                }), 128))
            ])
        ]))
        : (_openBlock(), _createBlock(_component_product_condition_info, { key: 1 }));
}
